import React, { useMemo } from 'react';

import { BlockMath } from 'react-katex';

import type { ActivityViewProps } from '../../core/types/activity.types';

import type { FormulaDestacadaPayload } from '../../core/types/payloads/guide_editorial.types';

import { useRoomContext } from '../../core/client/RoomContext';

import {

  humanizeConceptFormulaText,

  isHumanitiesFormulaSubject,

  normalizeLatexString,

} from './guide_editorial.logic';



export function FormulaDestacada({

  payload,

  subjectTag,

}: {

  payload: FormulaDestacadaPayload;

  subjectTag?: string;

}) {

  const latex = useMemo(

    () =>

      normalizeLatexString(

        String(payload.latex || (payload as { formula?: string }).formula || '').trim(),

      ),

    [payload],

  );

  const humanities = isHumanitiesFormulaSubject(subjectTag);

  const conceptText = useMemo(

    () => (humanities ? humanizeConceptFormulaText(latex) : latex),

    [humanities, latex],

  );

  const title = String(payload.title || '').trim();



  if (humanities) {

    const body = [conceptText, payload.description ? String(payload.description) : '']
      .filter(Boolean)
      .join('\n\n');

    return (

      <aside className="formula-destacada rounded-xl border border-[var(--sala-border)] bg-[rgba(124,106,173,0.08)] p-8 print:border-[#ccc] print:bg-[#f5f2fa]">

        {title ? (
          <p className="mb-3 text-sm font-semibold uppercase tracking-wide text-[var(--sala-ink-dim)] print:text-[#555]">
            {title}
          </p>
        ) : null}

        {body ? (
          <p className="font-sans text-base leading-relaxed text-[var(--sala-ink)] print:text-slate-800 whitespace-pre-line">
            {body}
          </p>
        ) : null}

      </aside>

    );

  }



  return (

    <div className="formula-destacada max-w-full rounded-xl border border-[var(--sala-border)] bg-[rgba(124,106,173,0.08)] p-8 text-center print:border-[#ccc] print:bg-[#f5f2fa]">

      {latex ? (

        <div className="formula-destacada__math formula-destacada__katex mx-auto flex w-full max-w-full min-w-0 justify-center overflow-x-auto overflow-y-hidden py-2 text-xl md:text-2xl [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">

          <BlockMath math={latex} errorColor="var(--sala-ink-muted)" />

        </div>

      ) : null}

      {payload.description ? (

        <p className="formula-destacada__desc mt-4 text-sm italic text-[var(--sala-ink-dim)] print:text-[#555]">

          {payload.description}

        </p>

      ) : null}

    </div>

  );

}



export function FormulaDestacadaActivityView(props: ActivityViewProps<'formula_destacada'>) {

  const room = useRoomContext();

  const subjectTag = room.state.state?.core.activity.subjectTag;

  return <FormulaDestacada payload={props.payload} subjectTag={subjectTag} />;

}


